import script from "./ArticleQuantityInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./ArticleQuantityInput.vue?vue&type=script&setup=true&lang=ts"

import "./ArticleQuantityInput.vue?vue&type=style&index=0&id=42ab83d7&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42ab83d7"]])

export default __exports__